export const UPDATING_ACCOUNT_USER = 'UPDATING_ACCOUNT_USER';
export const UPDATING_ACCOUNT_INIT = 'UPDATING_ACCOUNT_INIT';
export const UPDATING_ACCOUNT_RELOAD = 'UPDATING_ACCOUNT_RELOAD';
export const UPDATING_ACCOUNT_ROLE = 'UPDATING_ACCOUNT_ROLE';
